/**
 * Live Demo / Login CTA target for the marketing site.
 *
 * The long-term intent is an SSO deep-link into dev Nexus. That SSO work is tracked
 * separately (sibling item dev-sso-fix-for-marketing-reskin). Until it lands, the
 * marketing "Live Demo" / "Login" CTAs fall back to a PLAIN LINK to the dev Nexus
 * login page so this re-skin can ship unblocked.
 *
 * The Nexus base is baked in at docker build time via the REACT_APP_NEXUSCHAT_URL
 * build-arg (NOT read at runtime). The localhost-style fallback only applies to a
 * local dev build with no build-arg; dev builds point this at the dev Nexus host.
 */
const NEXUS_BASE = (process.env.REACT_APP_NEXUSCHAT_URL || 'https://dev-chat.videxa.ai')
  .replace(/\/+$/, '');

// Plain link to the dev Nexus login page (SSO deep-link to replace this later).
export const NEXUS_LOGIN_URL = `${NEXUS_BASE}/login`;

export default NEXUS_LOGIN_URL;
